import ReactDOM from 'react-dom'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import { useAppBarTarget } from '@/common/contexts/AppBarTargetContext'

const classes = {
    appBar: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}

const AppBarPortal = ({ children }) => {
    const target = useAppBarTarget()
    return target ? ReactDOM.createPortal(<Box sx={classes.appBar}>{children}</Box>, target) : null
}

AppBarPortal.propTypes = {
    children: PropTypes.node,
}

export default AppBarPortal
